$(window).on('load', function () {
  // Destroy existing slick if already initialized to prevent duplicate errors
  if ($('.c-main-slider').hasClass('slick-initialized')) {
    $('.c-main-slider').slick('unslick');
  }
  if ($('.c-thumb-slider').hasClass('slick-initialized')) {
    $('.c-thumb-slider').slick('unslick');
  }

  // Initialize Main Slider
  $('.c-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
  swipe: false,
    fade: true,
    asNavFor: '.c-thumb-slider'
  });

  // Initialize Thumbnail Navigation Slider
  $('.c-thumb-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.c-main-slider',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    infinite: false,
    draggable: false,
  });
});

$(document).on('click', '.c-product-rating', function (e) {
    e.preventDefault();

    $('html, body').stop().animate({
        scrollTop: $('#hooha-reviews-custom-reviews-section').offset().top
    }, 800, 'swing');
});
$(document).on('click', '.cc-product-rating', function (e) {
    e.preventDefault();

    $('html, body').stop().animate({
        scrollTop: $('#hooha-reviews-custom-reviews-section').offset().top
    }, 800, 'swing');
});
